import head from '../images/roles/head.svg'
import head_mini from '../images/roles/head_mini.svg'
import clients from '../images/roles/clients.svg'
import clients_mini from '../images/roles/clients_mini.svg'
import repair from '../images/roles/repair.svg'
import repair_mini from '../images/roles/repair_mini.svg'
import finance from '../images/roles/finance.svg'
import finance_mini from '../images/roles/finance_mini.svg'
import hr from '../images/roles/hr.svg'
import hr_mini from '../images/roles/hr_mini.svg'
import load_manager from '../images/roles/load_manager.svg'
import load_manager_mini from '../images/roles/load_manager_mini.svg'

export const USER_ROLE_KEY = "player";
export const MODER_ROLE_KEY = "moderator";
export const AUTH_TOKEN_STORAGE_KEY = "auth_token";
export const TEAMS_COUNT = 4;
export const PLAYERS_IN_TEAMS_COUNT = 6;
export const STATES_USER_COUNT = 8;
export const STATE_NAMES = ['Приветствие', 'Подтвердите название', 'Подтвердите логотип', 'Подтвердите роли', 'Подтвердите цели', 'Подтвердите ценности', 'Презентация команды', 'Обучение']
export const ROLES_COUNT = 6
export const TUTORIAL_SET_STATE = 7;
export const TEAM_OVERVIEW_STATE = 6;
export const VALUES_SET_STATE = 5
export const GOAL_SET_STATE = 4
export const ROLE_SET_STATE = 3
export const LOGO_SET_STATE = 2
export const NAME_SET_STATE = 1
export const WELCOME_STATE = 0
export const IMAGE_MIME_TYPES = ['image/jpeg', 'image/png']
export const ROLE_NAMES = ['', 'Руководитель компании', 'Зам. по работе с клиентами', 'Зам. по инфраструктуре и ремонту', 'Зам. по экономике и финансам', 'Зам. по кадрам и социальным вопросам', 'Заместитель по тяге'];
export const ROLE_NAMES_BIG_CARD = [null, <div>Руководитель <br/>компании</div>,
  <div>зам.<br/> по работе<br/> с клиентами </div>, <div>Зам.<br/> по инфраструктуре<br/> и ремонту</div>,
  <div>Зам.<br/> по экономике<br/> и финансам </div>, <div>Зам. по кадрам <br/> и социальным<br/> вопросам </div>,
  <div>Заместитель<br/>по тяге </div>];
export const CURRENT_USER_COLOR = '#F29C14'
export const CURRENT_USER_TEXT = ' (ВЫ)'
export const ROLE_IMAGES_BIG = [null, head, clients, repair, finance, hr, load_manager]
export const ROLE_IMAGES_MINI = [null, head_mini, clients_mini, repair_mini, finance_mini, hr_mini, load_manager_mini]

export const ROLE_COLORS = [null, '#FFCC33', '#00CC99', '#FF3366', '#6666FF', '#33CCFF', '#FF4E2C']
export const ELECTRO_TYPE = "electro";
export const LOCO_TYPE = "loco";
export const INFRA_TYPE = "infra";
export const SPARE_PARTS_TYPES = [ELECTRO_TYPE, LOCO_TYPE, INFRA_TYPE]
export const getLocoName = (type) => {
  if (ELECTRO_TYPE === type) {
    return "ЭЛЕКТРОВОЗ";
  }
  return "ТЕПЛОВОЗ";
}

export const REPAIR_SHOP_NAMES = {
  "electro": "Депо по ремонту эл-возов", "loco": "Депо по ремонту тепловозов", "infra": "Ремонт инфраструктуры"
}

export const STATION_NAMES = ["Анино", "Коршуново", "Архиповка", "Озёрная"]
export const STATION_COLORS = [0xC4C4C4, 0xC4C4C4, 0xFE5216, 0xC4C4C4]
export const BrigadesLabel = "Бригады";
export const WorkChipsLabel = "Трудозатраты";

export const GAME_STATE_NAMES = ["Начало дня", "Утро", "День", "Вечер", "Конец дня"]
export const DAY_NAMES = ["ПН", "ВТ", "СР", "ЧТ"]

export const GAME_BUTTONS_NEXT_NAME = ["Начать год", "Начать утро", "Закончить утро", "Закончить день", "Закончить вечер", "Закончить день"]
export const TRAIN_SORT_POPUP_ID = "trainSort";
export const REPAIR_POPUP_ID = "repair";
export const TRAIN_CREATE_ID = "trainCreate";
export const GAME_CARD_ID = "gameCard";
export const CargoNames = {
  "coal": "Уголь",
  "prod": "С/х продукция",
  "containerWithCargo": "Конт. груж",
  "containerEmpty": "Хлопок",
  "cement": "Цемент",
  "empty": "Порожний",
  "chem": "Химия",
  "metal": "Металл",
  "paper": "Бумага"
}
export const REPAIR_SHOP_NAMES_ARRAY = [REPAIR_SHOP_NAMES["electro"], REPAIR_SHOP_NAMES["loco"], REPAIR_SHOP_NAMES["infra"]]
export const GetNameByTypeAndID = (type, id) => {
  switch (type) {
    case "dispetcher":
      return "Диспетчерская";
    case "station":
      return STATION_NAMES[id];
    case "repair":
      return REPAIR_SHOP_NAMES_ARRAY[id];
    default:
      break;
  }
}
export const GET_FUEL_COST = 0.14;
export const GET_ELECTRICITY_COST = 0.01;

export const CLIENT_NAMES = {
  "rc": "РОСУГОЛЬ",
  "ap": "АГРОПРОМ",
  "av": "АВТОВАЗ",
  "bt": "БЕТОНАР",
  "act": "АЛЬФА ЦЕМЕНТ",
  "pt": "ПЯТЁРОЧКА",
  "kt": "КГОК",
  "bkt": "БОКСИТОГОРСК",
  "acbk": "АРХАНГЕЛЬСКИЙ ЦБК",
  "le": "ЛАДЬЯ-ЭКСПО"
}
export const MAX_ERROR_TIMEOUT = 10000;

export const TENDER_RESEARCHES = {
  "bt": {
    name: "БЕТОНАР",
    price: 20,
    loadDayWeight: 6,
    unloadDayWeight: 30,
    npsWeight: 6,
    expWeight: 30,
    creditWeight: 8,
  },
  "act": {
    name: "АЛЬФА ЦЕМЕНТ",
    price: 50,
    loadDayWeight: 6,
    unloadDayWeight: 6,
    npsWeight: 30,
    expWeight: 4,
    creditWeight: 4,
  },
  "pt": {
    name: "ПЯТЁРОЧКА",
    price: 50,
    loadDayWeight: 6,
    unloadDayWeight: 6,
    npsWeight: 30,
    expWeight: 4,
    creditWeight: 4,
  },
  "kt": {
    name: "КГОК",
    price: 50,
    loadDayWeight: 4,
    unloadDayWeight: 4,
    npsWeight: 6,
    expWeight: 6,
    creditWeight: 30,
  },
  "bkt": {
    name: "БОКСИТОГОРСК",
    price: 42,
    loadDayWeight: 22,
    unloadDayWeight: 3,
    npsWeight: 9,
    expWeight: 2,
    creditWeight: 22,
  },
  "acbk": {
    name: "АРХАНГЕЛЬСКИЙ ЦБК",
    price: 20,
    loadDayWeight: 6,
    unloadDayWeight: 6,
    npsWeight: 30,
    expWeight: 30,
    creditWeight: 8,
  },
  "le": {
    name: "ЛАДЬЯ-ЭКСПО",
    price: 20,
    loadDayWeight: 4,
    unloadDayWeight: 30,
    npsWeight: 10,
    expWeight: 6,
    creditWeight: 30,
  },
};
